import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { PtyLdService } from '../../services/pty-ld.service';
import { ModalController } from '@ionic/angular';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-seeker-request-document',
    templateUrl: './seeker-request-document.component.html',
    styleUrls: ['./seeker-request-document.component.scss'],
})
export class SeekerRequestDocumentComponent implements OnInit {

    userData: any;
    selectedFiles: FileList;
    fileData: any = [];
    document_title: string = '';

    myData: any = [];
    adminData: any = [];
    currentLangID = 184;

    constructor(
        private auth: AuthService,
        private loaderService: PtyLdService,
        private modalCtrl: ModalController,
        private ws: PtyWsService,
        private _translationService: TranslationService
    ) {
        // this.getData();
    }

    ngOnInit() {
        this.getDefaultLang();
        this.getS3BucketData();
    }

    getDefaultLang() {
        const self = this;
        self.ws.invokeURL('get_default_language', {}).subscribe((res: any) => {
            if (res.error === 0) {
                this.currentLangID = res.result[0].language_id;
            }
            self.loaderService.showLoading(false);
        }, (err: any) => {
            self.loaderService.showLoading(false);
            self.loaderService.showToast(this._translationService.translate('UnknownError'));
        });
    }

    getS3BucketData() {
        const self = this;
        //  this.loaderService.showLoading(true);
        self.ws.invokeURL('get_files', {}).subscribe((result: any) => {
            if (result.error === 0) {
                result.files.forEach(element => {
                    const dotIndex = element.url.lastIndexOf('.');
                    const ext = element.url.substring(dotIndex);
                    if (ext.includes('png') || ext.includes('jpg') || ext.includes('jpeg') || ext.includes('gif')) {
                        element.file_type = 'image';
                        // tslint:disable-next-line: max-line-length
                    } else if (ext.includes('mp4') || ext.includes('avi') || ext.includes('mov') || ext.includes('webm') || ext.includes('wmv')) {
                        element.file_type = 'video';
                    } else {
                        element.file_type = 'file';
                    }

                    this.fileData.push(element);
                });

                this.myData = this.fileData.filter(e => e.uploaded_by === 'O');
                this.adminData = this.fileData.filter(e => e.uploaded_by !== 'O' && e.language_id === this.currentLangID);
                this.loaderService.showLoading(false);

                //passing reordered data
                let mydata = JSON.parse(localStorage.getItem('myDataInstorage'));
                if (mydata) {
                    this.myData = mydata;
                }
            }
        }, (err: any) => {
            this.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
        });
    }

    selectedMessage(item) {
        this.dismiss(item);
        // if (event.target.src !== undefined && event.target.src !== '') {
        //     this.dismiss(event.target.src);
        // } else if (event.srcElement.currentSrc) {
        //     this.dismiss(event.srcElement.currentSrc);
        // } else if (event.srcElement.textContent) {
        //     this.dismiss(event.srcElement.textContent);
        // }
    }

    getData() {
        this.userData = this.auth.userData;
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    async upload() {
        const self = this;
        const file = self.selectedFiles.item(0);
        const fileBase64 = await this.getBase64(file);
        var idxDot = file.name.lastIndexOf(".") + 1;
        var extFile = file.name.substr(idxDot, file.name.length).toLowerCase();

        if (extFile == 'jpeg' || extFile == 'jpg' || extFile == 'png' || extFile == 'gif' || extFile == 'mp4' || extFile == 'avi' || extFile == 'mov' || extFile == 'webm' || extFile == 'wmv' || extFile == 'pdf' || extFile == 'txt') {
            this.loaderService.showLoading(true);
            self.ws.invokeURL('file_upload', { file: fileBase64 }).subscribe((result: any) => {
                if (result.success) {
                    // tslint:disable-next-line: max-line-length
                    self.ws.invokeURL('save_files', { url: result.data.full_path, type: result.data.type, title: this.document_title }).subscribe((response: any) => {
                        if (response.error === 0) {
                            const dotIndex = response.result.url.lastIndexOf('.');
                            const ext = response.result.url.substring(dotIndex);
                            if (ext.includes('png') || ext.includes('jpg') || ext.includes('jpeg') || ext.includes('gif')) {
                                response.result.file_type = 'image';
                                // tslint:disable-next-line: max-line-length
                            } else if (ext.includes('mp4') || ext.includes('avi') || ext.includes('mov') || ext.includes('webm') || ext.includes('wmv')) {
                                response.result.file_type = 'video';
                            } else {
                                response.result.file_type = 'file';
                            }
                            this.fileData.push(response.result);
                            this.myData.push(response.result);
                        }
                        this.loaderService.showLoading(false);
                    });
                }
            }, (err: any) => {
                this.loaderService.showLoading(false, {message: this._translationService.translate('UploadError')});
            });
        } else {
            this.loaderService.showToast(this._translationService.translate('FileNotSupported'));
        }
    }

    deleteDocument(item) {
        const self = this;
        this.loaderService.showLoading(true);
        self.ws.invokeURL('delete_file', { documentUUID: item.uuid }).subscribe((result: any) => {
            if (result.error === 0) {
                const index = this.fileData.findIndex(x => x.uuid === item.uuid);
                if (index !== -1) {
                    this.fileData.splice(index, 1);
                }
                this.loaderService.showLoading(false);
            }
        }, (err: any) => {
            this.loaderService.showLoading(false, { message: this._translationService.translate('UnknownError') });
        });
    }

    async dismiss(data: any = '') {
        await this.modalCtrl.dismiss(data);
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
}
